module.exports = __webpack_public_path__ + "static/txtling3-1024x850-9621207b45af2fba4dcce5df1ed55325.png";